import { createEntityAdapter } from '@reduxjs/toolkit';
import { IEppTerminalType } from 'application/components/api/EppTerminalType';

export const eppTerminalTypeAdapter = createEntityAdapter<IEppTerminalType, number>({
  selectId: (project) => project.eppTerminalTypeID,
});
